import React, { type FC, type PropsWithChildren, type ReactNode } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalBody from "react-bootstrap/ModalBody";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalFooter from "react-bootstrap/ModalFooter";
import "./styles.scss";

interface Props {
  id?: string;
  isOpen: boolean;
  hideHeader?: boolean;
  onClose: () => void;
  header?: ReactNode;
  footer?: ReactNode;
  size?: "sm" | "xl" | "lg";
}

const KC_Modal: FC<PropsWithChildren<Props>> = (props) => {
  return (
    <Modal
      id={props.id}
      className="kc-modal-v1"
      show={props.isOpen}
      onHide={props.onClose}
      size={props.size}
      centered={true}
    >
      {!props.hideHeader && (
        <ModalHeader closeButton={true}>
          <ModalTitle>{props.header}</ModalTitle>
        </ModalHeader>
      )}
      <ModalBody>{props.children}</ModalBody>
      {!!props.footer && <ModalFooter>{props.footer}</ModalFooter>}
    </Modal>
  );
};

export default KC_Modal;
